import { render, staticRenderFns } from "./NominationFormList.vue?vue&type=template&id=4507bc94"
import script from "./NominationFormList.vue?vue&type=script&lang=js"
export * from "./NominationFormList.vue?vue&type=script&lang=js"
import style0 from "./NominationFormList.vue?vue&type=style&index=0&id=4507bc94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports